import { DISCLAIMER_MAX_LENGTH, fillDisclaimer } from '../../utils/insuranceDisclaimer';

const hintStyle = { fontSize: '0.75rem', color: 'var(--admin-text-muted)', marginTop: '0.25rem' } as const;

/**
 * Spec 072 — one disclaimer language: textarea, character counter, and the filled-in preview.
 *
 * Shared by the provider form and (#1254) the Zofeur card. `idPrefix` keeps each form's ids and test
 * ids its own: `<prefix>-disclaimer-en`, `<prefix>-disclaimer-preview-en`, and the form's shared
 * `<prefix>-disclaimer-error`.
 */
export default function DisclaimerField({ idPrefix, lang, label, value, amount, disabled, invalid, onChange }: {
  idPrefix: string;
  lang: 'en' | 'ar';
  label: string;
  value: string;
  amount: number | null;
  disabled: boolean;
  invalid: boolean;
  onChange: (value: string) => void;
}) {
  const id = `${idPrefix}-disclaimer-${lang}`;
  const rtl = lang === 'ar';
  return (
    <div>
      <label className="admin-form-label" htmlFor={id}>{label}</label>
      <textarea
        id={id}
        data-testid={id}
        className="admin-form-input"
        rows={4}
        dir={rtl ? 'rtl' : 'ltr'}
        lang={lang}
        value={value}
        disabled={disabled}
        aria-invalid={invalid}
        aria-describedby={`${id}-count${invalid ? ` ${idPrefix}-disclaimer-error` : ''}`}
        onChange={(e) => onChange(e.target.value)}
        style={{ resize: 'vertical', fontFamily: 'inherit' }}
      />
      <div
        id={`${id}-count`}
        style={{ ...hintStyle, textAlign: rtl ? 'left' : 'right', color: value.length > DISCLAIMER_MAX_LENGTH ? 'var(--admin-danger)' : hintStyle.color }}
      >
        {value.length} / {DISCLAIMER_MAX_LENGTH}
      </div>
      {value.trim() && (
        <div
          data-testid={`${idPrefix}-disclaimer-preview-${lang}`}
          dir={rtl ? 'rtl' : 'ltr'}
          lang={lang}
          style={{ ...hintStyle, padding: '0.5rem 0.625rem', background: 'var(--admin-bg)', borderRadius: '6px' }}
        >
          <span style={{ fontWeight: 600 }}>{rtl ? 'معاينة: ' : 'Preview: '}</span>
          {fillDisclaimer(value.trim(), amount)}
        </div>
      )}
    </div>
  );
}
